// src/services/http.ts
import { getBasicAuth } from "./authStorage";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export async function request<TResponse>(
  path: string,
  options: {
    method?: HttpMethod;
    body?: unknown;
    headers?: Record<string, string>;
    auth?: "basic" | "none";
  } = {}
): Promise<TResponse> {
  const { method = "GET", body, headers = {}, auth = "basic" } = options;

  const basic = auth === "basic" ? getBasicAuth() : null;

  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(basic ? { Authorization: basic } : {}),
      ...headers,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const isJson = res.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const message =
      typeof data === "object" && data && "message" in data
        ? String((data as any).message)
        : `Error HTTP ${res.status}`;
    throw new Error(message);
  }

  return data as TResponse;
}

export const http = { request };